export const ReceiptsActionTypes = {
  SET_PROPERTY_UID_FOR_RECEIPTS: 'SET_PROPERTY_UID_FOR_RECEIPTS',
  SET_RECEIPTS_FROM_DATABASE: 'SET_RECEIPTS_FROM_DATABASE',
  ADD_RECEIPT: 'ADD_RECEIPT',
}
